
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payouts/[slug]",
      function () {
        return require("private-next-pages/payouts/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payouts/[slug]"])
      });
    }
  